import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { AboutPage } from './pages/AboutPage';
import { GalleryPage } from './pages/GalleryPage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { BookingPage } from './pages/BookingPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3" />} data-id="element-2">
          <Route index element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="services" element={<ServicesPage data-id="element-7" />} data-id="element-6" />
          <Route path="about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
          <Route path="gallery" element={<GalleryPage data-id="element-11" />} data-id="element-10" />
          <Route path="testimonials" element={<TestimonialsPage data-id="element-13" />} data-id="element-12" />
          <Route path="booking" element={<BookingPage data-id="element-15" />} data-id="element-14" />
        </Route>
      </Routes>
    </BrowserRouter>;
}